module.exports = __webpack_public_path__ + "static/media/pink_card_bg_ar.fbf25057.png";